<template>
  <component :is="`h${size}`"><slot></slot></component>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      default: 2,
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  @include fontStyleH1;
}
h2 {
  @include fontStyleH2;

  span {
    @include fontStyleCopyRegular;
    white-space: nowrap;
  }
}
h3 {
  @include fontStyleH3;
}

h4 {
  @include fontStyleH4;
}
</style>
